
import { defineStore } from 'pinia';

export const useAuthStore = defineStore({
    id: 'auth',
    state: () => ({
        user: JSON.parse(localStorage.getItem('user')),
        token: localStorage.getItem('token'),
        api: process.env.MIX_API_URL,
        showPersonSearch: false,
        showFAQ: false,
    }), 
});